import axios from 'axios';
import debounce from 'lodash/debounce'

const API_BASE = '/api/lri/data';
const config = require('../config/dev.json');

const debouncedPost = debounce(
    (dto, resolve, reject) => {
        _postLRIData(dto).then(resolve).catch(reject)
    },
    5000,
    {leading: false, trailing: true}
)

export const setLRIData = dto => {
    return new Promise((resolve, reject) => {
        debouncedPost(dto, resolve, reject)
    })
}

export const getLRIData = async ({projectId, version}) => {
    if (!projectId) {
        return {};
    }
    const origin = window.location.origin;
    const referer = document.referrer;
    try {
        const response = await axios.get(config.base_URL + API_BASE, {
            params: {projectId, version: version || 'v_0'},
            headers: {
                'Origin_URL': origin,
                'Referer_URL': referer,
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*'
            }
        });
        return response.data;
    } catch (error) {
        console.error('getLRIData failed:', error);
        throw error;
    }
};

export const _postLRIData = async (dto) => {
    if (!dto.projectId) {
        return {};
    }
    const origin = window.location.origin;
    const referer = document.referrer;
    try {
        const response = await axios.post(
            config.base_URL + API_BASE,
            dto,
            {
                headers: {
                    'Origin_URL': origin,
                    'Referer_URL': referer,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('setLRIData failed:', error);
        throw error;
    }
};

export const getLRIAverages = async ({industryRole}) => {
    try {
        const {lriIndustryScoresAvg, lriPeerScoresAvg} =
            await axios.get(
                `${config.base_URL}${API_BASE}/averages`,
                {params: {industryRole}}
            ).then(r => r.data);

        return {lriIndustryScoresAvg, lriPeerScoresAvg};
    } catch (error) {
        console.error(error);
        return {};
    }
};

